import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { SessionActivity } from "./interface";

interface UserActivity {
  userId: string;
  sessionCount: number;
}

interface DailyPlotProps {
  sessionActivities: SessionActivity[];
}

export const UserLoginPlot: React.FC<DailyPlotProps> = ({
  sessionActivities,
}) => {
  // Transform the sessionActivities data into a format suitable for the chart
  const data: UserActivity[] = sessionActivities.reduce((acc, session) => {
    const { userId } = session;

    const existingUser = acc.find((user) => user.userId === userId);
    if (existingUser) {
      existingUser.sessionCount += 1;
    } else {
      acc.push({
        userId,
        sessionCount: 1,
      });
    }

    return acc;
  }, [] as UserActivity[]);

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ marginBottom: 10 }}>
        <span style={{ fontSize: 16, fontWeight: "bold" }}>
          User Login Counts (Total Sessions: {sessionActivities.length})
        </span>
      </div>
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="userId" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="sessionCount" fill="#82ca22" />
      </BarChart>
    </div>
  );
};
